import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

export const getCtaButtonSx = (theme: Theme) =>
	({
		width: { xs: '100%', md: 280 },
		maxWidth: { xs: 345, md: 280 },
		minHeight: 80,
		px: 3,
		borderRadius: '8px',
		backgroundColor: theme.palette.loginOverlayCta.main,
		color: theme.palette.loginOverlayCta.contrastText,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		fontFamily: '"DIN Next LT Pro"',
		fontSize: '1.125rem',
		fontStyle: 'normal',
		fontWeight: 400,
		lineHeight: '1.625rem',
		letterSpacing: '-0.05px',
		transition: 'background-color 180ms ease',
		'&:hover': {
			backgroundColor: theme.palette.loginOverlayCta.dark ?? theme.palette.loginOverlayCta.main
		},
		'&:focusVisible': {
			outline: `2px solid ${alpha(theme.palette.text.secondary, 0.45)}`,
			outlineOffset: 3
		}
	}) as const;
